/**
 * Progressive enhancement for the "Return to Scrum.org" / "Continue Shopping"
 * links on the cart page.
 *
 * The link's href is a real, environment-specific URL (resolved server-side by
 * snippets/main-site-url.liquid), so with JavaScript disabled — or on a
 * middle-click / modified-click — it behaves like a normal link back to the
 * marketing site.
 *
 * When JS is available and the shopper arrived on this page directly from the
 * marketing site, we upgrade the click to history.back() so they return to the
 * exact page they came from (which a plain href can't do, since the browser
 * strips the referrer path cross-origin). Otherwise we leave the normal link
 * navigation alone.
 */

/**
 * Parse the hostname out of a URL. Returns '' for anything that isn't a valid
 * absolute URL, so callers fail closed to normal link navigation.
 */
function hostnameOf(url) {
  try {
    return new URL(url).hostname.toLowerCase();
  } catch (e) {
    return '';
  }
}

/**
 * Derive the set of referrer hostnames we treat as "the main site" from the
 * link's own href. Normalises the leading `www.` and accepts both the bare and
 * `www.` forms, so a referrer from either variant of the (environment-specific)
 * marketing site counts.
 */
function getAllowedHosts(url) {
  var host = hostnameOf(url);
  if (!host) {
    return [];
  }
  var bare = host.replace(/^www\./, '');
  return [bare, 'www.' + bare];
}

/**
 * Whether the visitor arrived on the current page directly from the main site,
 * based on document.referrer's host.
 */
function cameFromMainSite(mainSiteUrl) {
  var referrer = document.referrer;
  if (!referrer) {
    return false;
  }
  var referrerHost = hostnameOf(referrer);
  if (!referrerHost) {
    return false;
  }
  return getAllowedHosts(mainSiteUrl).indexOf(referrerHost) !== -1;
}

/**
 * Return the shopper to the previous page via history.back() so they land on
 * the exact page they came from. If that doesn't navigate away shortly (e.g.
 * this was the first real entry despite a referrer), fall back to the given URL
 * so they aren't left stuck.
 */
function returnToPreviousPage(fallbackUrl) {
  var didNavigateAway = false;
  window.addEventListener('pagehide', function () {
    didNavigateAway = true;
  });

  setTimeout(function () {
    if (!didNavigateAway && fallbackUrl) {
      window.location.href = fallbackUrl;
    }
  }, 800);

  window.history.back();
}

/**
 * Wire up every cart return link. The click is only upgraded to history.back()
 * when doing so actually helps; in every other case the real href navigates.
 */
document.addEventListener('DOMContentLoaded', function () {
  var returnLinks = document.querySelectorAll('[data-cart-return-link]');

  returnLinks.forEach(function (returnLink) {
    returnLink.addEventListener('click', function (event) {
      // Let the browser handle new-tab / modified / non-left clicks normally.
      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return;
      }

      var mainSiteUrl = returnLink.getAttribute('href') || '';

      // Only upgrade to history.back() when it helps: the shopper came straight
      // from the main site and there's a previous entry to return to.
      if (window.history.length > 1 && cameFromMainSite(mainSiteUrl)) {
        event.preventDefault();
        returnToPreviousPage(mainSiteUrl);
      }
      // Otherwise: do nothing and let the normal link navigation happen.
    });
  });
});
